import { chechIsStateValid, getAbbreviatedState, calculatePaymentCount } from "../../services/helper"
import { defaultUploadAllVendorColumns } from "../constants/defaultValues"
import { bulkUpdateChildColumnsValues, bulkUpdateMasterColumnsValues, validationCols, validationFields } from '../../utils/constants/reportFilters';

export const validateFieldValue = (col, value, isAdmin) => {
  if (typeof value === 'string') {
    value = value.trim()
  }

  if (col?.name === "erpVendorId" && typeof value === "number") {
    value = value.toString();
  }
  if (col?.required) {
    if (value === '' || value === null || value === undefined) {
      return (isAdmin && col.name !== 'suppliername') ? true : false
    }
  }
  if (!value || value === '' || value === null || value === undefined) {
    return true
  }
  if (col?.length) {
    if (JSON?.stringify(value)?.length !== col?.length) {
      return false
    }
  }
  if (col?.lengthNotGreater) {
    if (JSON?.stringify(value)?.length > col?.lengthNotGreater) {
      return false
    }
  }

  if ((col?.name === 'phone' || col?.name === 'cardPaymentByPhoneValue') && typeof value !== 'string' && value) {
    value = value?.toString()
  }

  if (col?.dataType === 'string' && col?.name !== 'companyId') {
    if (typeof value !== 'string') {
      return false
    }
  }
  if (col?.dataType === 'email') {
    return emailValidator(value)
  } else if (col?.dataType === 'date') {
    return validateDate(value)
  } else if (col?.dataType === 'currency') {
    return /^\d+(\.\d{0,2})?$/.test(value)
  } else if (col?.dataType === 'percent') {
    return /^\d{0,2}(\.\d{0,2})?$/.test(value)
  } else if (col?.name === 'taxId') {
    return /^(9)\d{2}-\d{2}-\d{4}$/i.test(value)
  } else if (col?.name === 'sic') {
    return /^\d{4}?$/i.test(value)
  } else if (col?.name === 'naics') {
    return /^(\d{5}|\d{6})?$/i.test(value)
  } else if (col?.name === 'phone' || col?.name === 'cardPaymentByPhoneValue') {
    let test = value?.toString().replace(/[^0-9]/g, '')
    return (/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(test) || /(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(test) || /(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(test))
  } else if (col?.name === 'employerIdNumber') {
    return /^(\d{2}-\d{7})?$/.test(value)
  } else if (col?.dataType === 'url') {
    return /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i.test(value)
  } else if (col?.name === 'zip' || col?.name === 'checkZip') {
    if (/^\d{5}((-|\s){0,1}\d{4})?$/.test(value) || /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z]( ?)[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i.test(value)) {
      return true
    } else {
      return false
    }
  } else if (col?.name === 'state') {
    return chechIsStateValid(value)
  } else if (col?.dataType === 'multiEmails') {
    const emails = value ? value?.split(',').map(email => email.trim().replace(/"/g, '')) : [];
    if (emails && emails?.length) {
      for (const email of emails) {
        if (!emailValidator(email)) {
          return false;
        }
      }
    }
  }
  return true
}

export const validateLinkedField = (rowData, column, field) => {
  const fieldKey = Object.keys(field).find(key => field[key].includes(column?.name));
  if (!rowData.hasOwnProperty(fieldKey)) {
    return false;
  }
  const isFieldValidate = validateFieldValue(column, rowData?.[column?.name])
  if (!isFieldValidate) {
    return isFieldValidate
  }

  if (!rowData[fieldKey]) {
    for (const linkedField of field[fieldKey]) {
      if (rowData[linkedField]) {
        return false;
      }
    }
    return true;
  } else {
    for (const linkedField of field[fieldKey]) {
      if (column?.name === 'creditCardRemittanceEmail' || column?.name === 'creditCardPaymentEmail') {
        if (rowData[linkedField]) {
          return true;
        }
      } else if (column?.name === 'isAcceptAmexVariableFee' || column?.name === 'isAcceptMasterCardVariableFee' || column?.name === 'isAcceptVisaVariableFee') {
        return true
      } else {
        if (rowData[linkedField]) {
          return true;
        }
      }
    }
    return false;
  }
};

const validateDate = (str) => {
  return Date.parse(Math.floor(str))
}

const formatStringDate = (date) => {
  // if (!Date.parse(date)) {
  //   return ''
  // }
  // const tmpDate = new Date(date)
  // const year = '' + tmpDate.getFullYear()
  // const month = '' + (tmpDate.getMonth() + 1)
  // const day = '' + tmpDate.getDate()
  // return [year, month, day].join('-')
  // const secondPerDay = 86400;
  // const minusDay = 25569;
  // const dateNumber = (date - minusDay) * secondPerDay;
  // var dateString = moment.unix(dateNumber).format("MM/DD/YYYY");
  // if (dateString === "Invalid date") { dateString = '' }
  // return dateString;
  if (typeof date == 'string' && date.indexOf('/') != -1)
    return date
  var utc_days = Math.floor(date - 25569);
  var utc_value = utc_days * 86400;
  var date_info = new Date(utc_value * 1000);

  var fractional_day = date - Math.floor(date) + 0.0000001;

  var total_seconds = Math.floor(86400 * fractional_day);

  var seconds = total_seconds % 60;

  total_seconds -= seconds;

  var hours = Math.floor(total_seconds / (60 * 60));
  var minutes = Math.floor(total_seconds / 60) % 60;

  // return `${date_info.getFullYear()}/${date_info.getMonth() + 1}/${date_info.getDate()}`
  return `${date_info.getUTCFullYear()}/${date_info.getUTCMonth() + 1}/${date_info.getUTCDate()}`
}

export const convertUploadedVendorData = (data, spendTimeFrame, spendTimeType, isAdmin, dataSourceType = "", supplierType = "") => {
  let updateZipForStates = ['CT', 'MA', 'ME', 'NH', 'NJ', 'PR', 'RI', 'VT']
  let tmpData = [...data]
  let uploadColumns = "";
  if (dataSourceType === 'bulkUpdate' && supplierType) {
    let namesArray = Object.entries(supplierType === 'master' ? bulkUpdateMasterColumnsValues : bulkUpdateChildColumnsValues).map(([key, value]) => ({
      ...value
    }));
    uploadColumns = namesArray
  } else {
    uploadColumns = defaultUploadAllVendorColumns
  }
  return tmpData.map(row => {
    const tmpRow = {}
    uploadColumns.forEach(col => {
      let value = (row[col.name] && row[col.name]?.toString()?.toLowerCase() === 'null') ? "" : row[col.name];
      if (dataSourceType === 'bulkUpdate' && validationCols?.includes(col.name)) {
        tmpRow[col.name] = {
          validate: validateLinkedField(row, col, validationFields),
          value: convertValueForType(value, col.dataType)
        }
      } else {
        if (col.name === "address1") {
          let regex = /\b(p\s*\.?\s*o\s*\.?\s*box)\s*/gi;;

          if (regex.test(value)) {
            let tmp = value.replace(regex, 'PO Box ');
            let valueTmp = tmp.replace(/PO Box\s*(?![0-9])/, 'PO Box ');
            value = valueTmp.replace(/\s+/g, ' ').trim();
          }
        }

        if (col.name === 'phone' || col.name === 'cardPaymentByPhoneValue') {
          let phoneValue = row[col.name]
          let isExt = row[col.name] && row[col.name].toString().match(/x|ext|ext./)
          if (isExt && isExt.length > 0) {
            let parsePhone = row[col.name].split(isExt[0])
            phoneValue = parsePhone[0].trim()
          }
          tmpRow[col.name] = {
            validate: validateFieldValue(col, phoneValue),
            value: convertValueForType(value, col.dataType)
          }
        } else if (col.name === 'employerIdNumber') {
          var einValue = value || ''
          if (value) {
            einValue = formatEmployerIdNumber(value)
          }
          tmpRow[col.name] = {
            validate: validateFieldValue(col, einValue, isAdmin),
            value: convertValueForType(einValue, col.dataType)
          }
        } else {
          if (col.name === 'zip' || col.name === 'checkZip') {
            value = (!value || value === null || value === undefined) ? value : value.toString().replaceAll(/[^a-zA-Z0-9_-]/g, '')
            let stateCode = getAbbreviatedState(null, row['state'])
            if (updateZipForStates?.includes(stateCode)) {
              if (value?.toString().length === 4) {
                value = '0' + row[col.name]
              } else if (value?.toString()?.includes("-")) {
                const parts = value?.toString()?.split('-');
                if (parts[0]?.toString()?.length === 4) {
                  parts[0] = '0' + parts[0];
                }
                value = parts?.join('-');
              }
            }
          }
          if (col.dataType === 'url') {
            const regex = /^(?:[a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

            if (row[col.name] && !row[col.name]?.startsWith('https://') && !row[col.name]?.startsWith('http://') && !row[col.name]?.startsWith('www.')) {
              if (regex.test(row[col.name])) {
                value = 'www.' + row[col.name]
              }
            }
          }
          tmpRow[col.name] = {
            validate: validateFieldValue(col, value, isAdmin),
            value: convertValueForType(value, col.name === 'zip' ? col.name : col.dataType)
          }
        }
      }
    })
    tmpRow['annualizedSpend'] = {
      validate: true,
      value: calcAnnualizedSpend(tmpRow['spend']?.value, spendTimeFrame, spendTimeType?.value),
    }

    return tmpRow
  })
}

export const emailValidator = (email) => {
  const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/gi
  if (!email || email === '') {
    return true
  }
  if (typeof email === 'string') {
    return email.match(regex) ? true : false
  }
  return false
}

const removeSpecialChar = (value) => {
  if (!value) {
    return 0
  }
  const valueStr = value.toString()
  return valueStr.replace(/[$,%]/g, '')
}

export const checkEmptyValue = (value) => {
  return value === null || value === undefined || value === ''
}

export const convertValueForType = (value, type, decimals = 2) => {
  if (typeof value === 'string') {
    value = value.trim()
  }
  let tmpValue = (value === null || value === undefined) ? '' : value
  switch (type) {
    case 'currency':
    case 'percent':
      if (value === '' || value === null || value === undefined || isNaN(value)) {
        return ''
      }
      return parseFloat(removeSpecialChar(value) || 0).toFixed(decimals)
    case 'number':
      return parseFloat(value || 0) || 0
    case 'digit':
      return parseInt(value || '') || ''
    case 'boolean':
      return (tmpValue === 'no' || tmpValue === 'No' || tmpValue === 'n' || tmpValue === 'N' || tmpValue === false) ? 0 : tmpValue ? 1 : null
    // case 'date':
    //   return formatStringDate(tmpValue)
    case 'integer':
      return parseInt(value || null) || null
    case 'checkZip':
    case 'zip':
      if (/^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i.test(tmpValue)) {
        tmpValue = tmpValue.replace(/.{3}/g, '$& ').trim()
      } else if (/^\d{9}?$/.test(tmpValue)) {
        tmpValue = tmpValue?.toString().replace(/.{5}/g, '$&-')
      }
      return tmpValue
    default:
      return typeof tmpValue === 'string' ? tmpValue.trim() : tmpValue
  }
}

export const calcAnnualizedSpend = (spend, spendTimeFrame, spendTimeType) => {
  if (spend === null || spend === 0 || spendTimeFrame === null || spendTimeFrame === 0) {
    return 0
  } else {
    switch (spendTimeType) {
      case 'years':
        return parseFloat(parseFloat(spend) / parseInt(spendTimeFrame))
      case 'months':
        return parseFloat(parseFloat(spend) * 12 / parseInt(spendTimeFrame))
      case 'days':
        return parseFloat(parseFloat(spend) * 365 / parseInt(spendTimeFrame))
      default:
        return 0
    }
  }
}

export const annualizedPaymentCount = (spendTimeType, spendTimeFrame, value) => {
  return calculatePaymentCount(spendTimeType, spendTimeFrame, value)
}

export const formatValue = (value, type, decimals = 2, currencySign = '$') => {
  let valueFixed = parseFloat(removeSpecialChar(value) || 0).toFixed(decimals)
  if (!valueFixed) {
    valueFixed = 0
  }
  const tmpValue = (value === null || value === undefined) ? '' : value

  switch (type) {
    case 'currency':
      if (tmpValue === '') {
        return ''
      }
      return currencySign + valueFixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    case 'percent':
      if (tmpValue === '') {
        return ''
      }
      return valueFixed + '%'
    case 'number':
      if (tmpValue === '') {
        return ''
      }
      return valueFixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    case 'removeZeroDecimal':
      return parseFloat(valueFixed).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    case 'boolean':
      // return parseInt(tmpValue) ? tmpValue : 0
      return tmpValue === '' ? null : parseInt(tmpValue) ? tmpValue : 0
    case 'date':
      return formatStringDate(tmpValue)
    default:
      return tmpValue
  }
}

export const parseMoneyAsFloat = (value, currency_sign) => {
  if (!value) {
    return 0
  }
  const valueStr = value.toString()
  return parseFloat(valueStr.replace(new RegExp(`[$,%${currency_sign}]`, 'g'), ''))
}

export const checkSpecialCharater = (str) => {
  const regexp = /[`ģń~!@#$%^*()_|=?;:",<>{}[]\\\/]/gi
  return str.match(regexp)
}

export const formatEmployerIdNumber = (employerIdNumber) => {
  const formattedEin = String(employerIdNumber).replace(/(\d{2})(\d{7})/, '$1-$2');
  return formattedEin;
}